import { LoadingButton } from "@mui/lab";
import { TextField } from "@mui/material";
import { t } from "i18next";
import React, { useState } from "react";
import { client } from "../../..";
import { upsertQBP } from "../../../api";
import { EnterLayout } from "../../../components/EnterLayout";
import { showErrorMessage } from "../../../helper/helper";
import { BidModel } from "../../../models/bid/BidModel";
import { Organisation, QualityLevel } from "../../../models/organisation/Organisation";
import { colorPrimary, colorPrimaryDark } from "../../../rsc/colors/colors";
import { PopupEditPrice } from "./PopupEditPrice";

type Props = {
    quality: QualityLevel
    bid: BidModel
    org: Organisation
}

export function QBPPriceRow({ quality, bid, org }: Props) {

    const [loading, setLoading] = useState(false)

    const [displayPopup, setDisplayPopup] = useState(false)

    const [newPrice, setNewPrice] = useState(quality.price_per_kg)
    const [priceInput, setPriceInput] = useState<string>(quality.price_per_kg?.toString())

    function isPriceSet(): boolean {
        return newPrice !== undefined && newPrice !== null
    }

    function getStyleForButton(): React.CSSProperties {
        if (loading) {
            return {
                backgroundColor: "grey",
                color: "grey"
            }
        } else {
            return {
                backgroundColor: isPriceSet() ? colorPrimaryDark : colorPrimary,
                color: "white"
            }
        }
    }

    function onInputChange(value: string) {
        const re = /^[0-9]+$/

        if (value.length === 0) {
            setPriceInput('')
        } else if (re.test(value)) {
            setPriceInput(value)
        }
    }

    function getPriceLayout() {
        if (!isPriceSet()) {
            return (<div style={{ display: "flex", alignItems: "center", flex: 1, justifyContent: "end" }}>
                <p className='greyColor' style={{ display: "inline-block", margin: "0 5px 0 0", fontWeight: "500" }}>Rp/Kg</p>
                <TextField
                    variant="standard"
                    // disabled={!props.isEditable(props.org, props.price)}
                    value={priceInput}
                    // error={onPriceError}
                    type='numeric'
                    inputProps={{ maxLength: 4, style: { textAlign: 'end', fontSize: "26px", fontWeight: "700", width: "60px", maxWidth: "5ch" } }}
                    onChange={(e) => onInputChange(e.target.value)}
                />
            </div>)
        } else {
            return <div style={{ display: "flex", alignItems: "center", flex: 1, justifyContent: 'end' }}>
                <p style={{ display: "inline-block", margin: "0" }}>Rp/Kg</p>
                <p style={{ display: "inline-block", margin: "0 0 0 5px", textAlign: 'end', fontSize: "26px", fontWeight: "700" }}>{newPrice}</p>
            </div>
        }
    }

    function onSave(price: string) {
        console.log('bid', bid)
        if (!bid.price_per_quantity_unit) {
            showErrorMessage(t('need_bid_for_qbp'))
        }else if (price.length === 0) {
            showErrorMessage(t('need_valid_number'))
        } else {
            const p = parseInt(price)
            setLoading(true)
            client.mutate({
                mutation: upsertQBP,
                variables: {
                    input: {
                        cardinality: quality.cardinality,
                        delta: parseInt(price),
                        market_id: bid.market_day,
                        organisation_id: org.id
                    }
                },
                context: {
                    headers: {
                        "role": "usermill"
                    }
                }
            }).then((data) => {
                setNewPrice(p)
                onCancel()
            }, (e: TypeError) => {
                showErrorMessage(e)
            }).finally(() => setLoading(false)
            )
        }
    }

    function onCancel() {
        setDisplayPopup(false)
    }

    return (
        <EnterLayout onClick={() => {
            if (isPriceSet()) {
                setDisplayPopup(true)
            } else {
                onSave(priceInput)
            }
        }}>
            <div style={{ display: "flex", alignItems: "center", paddingLeft: "10px", gap: '10px', marginBottom: '10px' }}>
                <div style={{ flex: 1 }}>
                    {quality.name}
                </div>
                {getPriceLayout()}
                <div style={{ flex: 1, display: "flex", justifyContent: "end" }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', fontWeight: '600' }}>
                        <p style={{ fontSize: '32px', color: colorPrimaryDark }}>{newPrice ? (newPrice ?? 0) + (bid?.price_per_quantity_unit ?? 0) : "-"}</p>
                    </div>
                </div>
                {
                    isPriceSet() ?
                        <LoadingButton
                            style={{ width: "100px", ...getStyleForButton() }}
                            variant="contained"
                            loading={loading}
                            onClick={() => {
                                setDisplayPopup(true)
                            }}>
                            {t('edit')}
                        </LoadingButton>
                        : <LoadingButton
                            style={{ width: "100px", ...getStyleForButton() }}
                            variant="contained"
                            loading={loading}
                            onClick={() => onSave(priceInput)}
                        >
                            {t('save')}
                        </LoadingButton>
                }
            </div>
            <PopupEditPrice price={newPrice}
                open={displayPopup}
                onSave={(np) => onSave(np)}
                onCancel={onCancel} />
        </EnterLayout>
    )
}